import SpinWrapper from './spin-wrapper';
export default SpinWrapper;
